"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_WINDOW = 'object' === typeof window;
exports.ENV = exports.IS_WINDOW && window.location.href.match('//localhost') ? 'dev' : 'prod';
exports.IS_DEV = exports.ENV == 'dev';
var config = {
    IS_WINDOW: exports.IS_WINDOW,
    IS_DEV: exports.IS_DEV,
    ENV: exports.ENV,
};
exports.default = config;
//# sourceMappingURL=env.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/env.js
// module id = lAjw
// module chunks = 0